import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Tooltip,
  Fab,
  Slide,
} from '@material-ui/core';
import { Add } from '@material-ui/icons';

// import NavBreadcrumbs from './CustomBreadcrumbs';
import Busqueda from './TabServiciosBusqueda';
import ServiciosIda from './TabServiciosIda';
import ServiciosVuelta from './TabServiciosVuelta';
import Backdrop from './Backdrop';

//actions
import { getServicios, resetBusquedaAction } from '../../redux/actions/serviciosActions';
import { enviarAutorizacion } from '../../redux/actions/autorizacionActions';

import validarFechaHora from '../../helpers/validacionFechaHora';
import validarRangoHorario from '../../helpers/validarRangoHorario';

import useStyles from './styles';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='up' ref={ref} {...props} />;
});

const FormDialog = ({ OnAgregarReserva, initialStatusOpen }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { token, esencialCC } = useSelector((state) => state.auth);
  const { solicitudID, error } = useSelector((state) => state.autorizaciones);
  const objBusqueda = useSelector((state) => state.servicios.busqueda);
  const objCantidad = useSelector((state) => state.servicios.cantidad);

  const serviciosSeleccionadoIda = useSelector(
    (state) => state.servicios.serviciosSeleccionados.ida
  );
  const serviciosSeleccionados = useSelector(
    (state) => state.servicios.serviciosSeleccionados
  );

  const [open, setOpen] = useState(initialStatusOpen.open);
  const [tabIndex, setTabIndex] = useState(initialStatusOpen.tabIndex);

  const [success, setSuccess] = useState(false);
  const [openBackdrop, setOpenBackdrop] = useState(false);
  const [reset, setReset] = useState(false);

  const handleBuscarServicios = () => {
    const query = {
      busqueda: objBusqueda,
      cantidad: objCantidad,
    };
    dispatch(getServicios({ ida: true, token, query }));
    setTabIndex(1);
  };

  useEffect(() => {
    if (error) {
      setOpenBackdrop(false);
      setTabIndex(0);
      dispatch(resetBusquedaAction());
    }
  }, [error]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleAgregarAutorizacion = () => {
    //if (!solicitudID) dispatch(getSolicitudId(token));
    const autorizacionObj = {
      solicitudID,
      serviciosSeleccionados,
    };
    dispatch(enviarAutorizacion(token, solicitudID, autorizacionObj, setSuccess));
    setOpen(false);
    setOpenBackdrop(true);
  };

  useEffect(() => {
    if (success) {
      OnAgregarReserva(true);
      setTabIndex(0);
      setOpen(false);
      dispatch(resetBusquedaAction());
      setSuccess(false);
      setOpenBackdrop(false);
    }
  }, [success, OnAgregarReserva, dispatch]);

  const handleReiniciar = () => {
    setReset(true);
    setOpenBackdrop(true);
    handleCancelarReserva();
    // setDataSearchServicio({ target: { name: 'hora', value: time } })
    setTimeout(() => {
      setOpen(true);
      setOpenBackdrop(false);
    }, 300);
  };

  const handleAgregarViaje = () => {
    setOpen(true);
  };

  const handleCancelarReserva = () => {
    // Reiniciar formulario
    setTabIndex(0);
    dispatch(resetBusquedaAction());
    setOpen(false);
  };

  const escFunction = (event) => {
    if (event.keyCode === 27) {
      handleCancelarReserva();
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', escFunction, false);
    return () => {
      document.removeEventListener('keydown', escFunction, false);
    };
  });

  const tabIndexView = (TabIndex) => {
    switch (TabIndex) {
      case 0:
        return <Busqueda reset={reset} setReset={setReset} />;
      case 1:
        return <ServiciosIda setTabIndex={setTabIndex} />;
      case 2:
        return <ServiciosVuelta setTabIndex={setTabIndex} />;
      default:
        return null;
    }
  };

  return (
    <div>
      <Backdrop open={openBackdrop} />
      <Tooltip title='Nuevo viaje' aria-label='add'>
        <Fab color='secondary' className={classes.absolute} onClick={handleAgregarViaje}>
          <Add />
        </Fab>
      </Tooltip>
      <Dialog
        open={open}
        aria-labelledby='form-dialog-title'
        fullWidth={true}
        maxWidth={'md'}
        TransitionComponent={Transition}
      >
        <DialogTitle id='form-dialog-title' className={classes.titleDialog}>
          Agregar viaje
        </DialogTitle>
        <DialogContent className={classes.DialogContent}>
          {/* <NavBreadcrumbs /> */}
          {tabIndexView(tabIndex)}
        </DialogContent>
        <DialogActions className={classes.footerModalAction}>
          <Button onClick={handleCancelarReserva} className={classes.floatLeft}>
            Cancelar
          </Button>

          {serviciosSeleccionadoIda === null ? (
            <>
              {tabIndex === 0 || tabIndex === 1 ? (
                <Button onClick={handleReiniciar}>Reintentar búsqueda</Button>
              ) : null}
              <Button
                onClick={handleBuscarServicios}
                color='primary'
                disabled={
                  !(
                    objBusqueda.linea &&
                    objBusqueda.estacionOrigen &&
                    objBusqueda.estacionDestino &&
                    esencialCC &&
                    // validarFechaHora(objBusqueda.fecha, objBusqueda.hora) &&
                    // validarRangoHorario(objBusqueda.hora) &&
                    tabIndex !== 1
                  )
                }
              >
                Buscar servicios
              </Button>
            </>
          ) : (
            ''
          )}
          {serviciosSeleccionadoIda !== null ? (
            <>
              <Button onClick={handleReiniciar}>Reintentar búsqueda</Button>
              <Button onClick={handleAgregarAutorizacion} color='primary'>
                Agregar viaje
              </Button>
            </>
          ) : (
            ''
          )}
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default FormDialog;
